import {
  selectDisplayName,
  selectTypingUsers,
  t,
} from '@alternativamais/chat-core';
import { useCliente, useEstado } from '../../chat/contexto';
import { useAgora } from '../../chat/ganchos';

/** "Fulano está digitando…" abaixo do compositor (some sozinho em 10 s). */
export function Digitando({
  canalId,
  guildId,
}: {
  canalId: string;
  guildId: string | null;
}) {
  const cliente = useCliente();
  const digitando = useEstado((estado) => estado.typing[canalId]);
  const agora = useAgora(1_000);
  const estado = cliente.store.getState();
  const nomes = digitando
    ? selectTypingUsers(estado, canalId, agora).map((id) =>
        selectDisplayName(estado, id, guildId),
      )
    : [];
  return (
    <div
      aria-live="polite"
      className="flex h-6 shrink-0 items-center gap-1.5 px-5 text-xs text-texto-2"
    >
      {nomes.length > 0 && (
        <>
          <span aria-hidden="true" className="digitando flex gap-[3px]">
            <span className="size-[5px] rounded-full bg-texto-2" />
            <span className="size-[5px] rounded-full bg-texto-2" />
            <span className="size-[5px] rounded-full bg-texto-2" />
          </span>
          <span className="truncate">
            {nomes.length > 3 ? t('digitando.varios') : <Frase nomes={nomes} />}
          </span>
        </>
      )}
    </div>
  );
}

function Frase({ nomes }: { nomes: string[] }) {
  const forte = (nome: string) => (
    <strong key={nome} className="font-bold text-texto">
      {nome}
    </strong>
  );
  if (nomes.length === 1) return <>{forte(nomes[0])} está digitando…</>;
  if (nomes.length === 2) {
    return (
      <>
        {forte(nomes[0])} e {forte(nomes[1])} estão digitando…
      </>
    );
  }
  return (
    <>
      {forte(nomes[0])}, {forte(nomes[1])} e {forte(nomes[2])} estão digitando…
    </>
  );
}
